// Gujarati translations
export const gu: Record<string, string> = {
  'menu.dashboard': 'ડેશબોર્ડ',
  'menu.customers': 'ગ્રાહકો',
  'menu.products': 'ઉત્પાદનો',
  'menu.users': 'વપરાશકર્તાઓ',
  'menu.settings': 'સેટિંગ્સ',
  'menu.logout': 'લૉગઆઉટ',
  'dashboard.title': 'ડેશબોર્ડ',
  'dashboard.newOrder': 'નવો ઓર્ડર',
  'order.title': 'નવો ઓર્ડર',
  'order.customer': 'ગ્રાહક',
  'order.products': 'ઉત્પાદનો',
  'order.total': 'કુલ',
  'users.title': 'વપરાશકર્તાઓ',
  'users.name': 'નામ',
  'users.email': 'ઈમેઇલ',
  'common.yes': 'હા',
  'common.no': 'ના',
  'common.cancel': 'રદ કરો',
  'common.save': 'સાચવો',
  'common.search': 'શોધો',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'લૉગિન',
  'login.welcome': 'સ્વાગત છે, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'ઈમેઇલ',
  'signup.phone': 'ફોન',
  'menu.reportsAndAccounting': 'રિપોર્ટ્સ અને હિસાબ',
  'menu.systemAndCommunication': 'સિસ્ટમ અને સંચાર',
};